import { Text, Heading, Button, Img } from "./..";
import React from "react";

export default function InnovativeCultureSection({
  headingText = "Innovative Culture",
  descriptionText = "At Zwilling Labs, we believe that innovation drives progress. Our team is encouraged to think outside the box, explore new ideas, and contribute to cutting-edge projects that shape the future of manufacturing.",
  ...props
}) {
  return (
    <div {...props} className={`${props.className} flex flex-col items-start justify-center gap-2.5`}>
      <Button
        size="5xl"
        variant="gradient"
        color="color_style_linear_gradient_gray_900_05"
        className="w-[58px] rounded-[28px] px-2"
      >
        <Img src="images/img_laptop.svg" />
      </Button>
      <Heading size="heading5xl" as="h5" className="text-[22.33px] font-bold text-color_style-01_neutrals-grey800">
        {headingText}
      </Heading>
      <Text
        size="text2xl"
        as="p"
        className="w-full text-[15.95px] font-normal leading-[23px] text-color_style-01_neutrals-grey800"
      >
        {descriptionText}
      </Text>
    </div>
  );
}
